export const getAssignedDataIdsValues = (dataIds, assignmentFieldData) => {
  let values = []
  dataIds.forEach((id) => {
    let listData = assignmentFieldData.find((it) => it.list_data_id == id)
    if (listData) {
      values.push(listData.list_data_value)
    }
  })

  return values.join(' | ')
}

export const arraysHaveSameElements = (arr1, arr2) => {
  // If lengths of arrays are different, they can't have the same elements
  if (arr1.length !== arr2.length) {
    return false
  }

  // Sort both arrays
  let sortedArr1 = arr1.slice().sort((a, b) => a - b)
  let sortedArr2 = arr2.slice().sort((a, b) => a - b)

  // Compare the sorted arrays element by element
  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) {
      return false
    }
  }

  // All elements are identical
  return true
}
